import React from 'react';
import { Hero } from '../components/Hero';
import { CompanyCard } from '../components/CompanyCard';
import { motion } from 'framer-motion';
import { Gamepad2, Globe, Shield } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
const companies = [{
  name: 'Neon Forge',
  description: 'Forging digital realities through quantum-powered game engines. Specialists in immersive VR experiences.',
  variant: 'blue' as const,
  stats: [{
    label: 'Active Users',
    value: '2.4M'
  }, {
    label: 'Uptime',
    value: '99.9%'
  }]
}, {
  name: 'Cyber Synapse',
  description: 'Neural interface gaming technology connecting mind and machine. The boundary is dissolving.',
  variant: 'pink' as const,
  stats: [{
    label: 'Latency',
    value: '<1ms'
  }, {
    label: 'Nodes',
    value: '50k+'
  }]
}, {
  name: 'Void Systems',
  description: 'Dark matter physics simulations for hyper-realistic space combat scenarios.',
  variant: 'blue' as const,
  stats: [{
    label: 'Systems',
    value: '892'
  }, {
    label: 'Rating',
    value: 'AAA'
  }]
}];
export function Home() {
  return <div className="min-h-screen bg-[#050814] text-white selection:bg-[#ff006e] selection:text-white scanlines" data-id="element-76">
      <Navbar data-id="element-77" />

      <main data-id="element-78">
        <Hero data-id="element-79" />

        {/* Featured Studios Section */}
        <section className="py-24 relative" data-id="element-80">
          <div className="container mx-auto px-6" data-id="element-81">
            <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6" data-id="element-82">
              <div data-id="element-83">
                <motion.h2 initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} className="text-4xl md:text-5xl font-bold mb-4" data-id="element-84">
                  ELITE{' '}
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00f0ff] to-[#ff006e]" data-id="element-85">
                    PARTNERS
                  </span>
                </motion.h2>
                <div className="h-1 w-24 bg-[#00f0ff]" data-id="element-86" />
              </div>
              <p className="font-mono text-gray-400 max-w-md text-sm md:text-right" data-id="element-87">
                Collaborating with the world's most advanced development studios
                to bring you the future of interactive entertainment.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-88">
              {companies.map((company, index) => <CompanyCard key={company.name} {...company} delay={index * 0.2} data-id="element-89" />)}
            </div>
          </div>
        </section>

        {/* Tech Specs Section */}
        <section className="py-24 bg-[#0a0e27] relative overflow-hidden" data-id="element-90">
          <div className="absolute inset-0 cyber-grid opacity-20" data-id="element-91" />

          <div className="container mx-auto px-6 relative z-10" data-id="element-92">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-93">
              <div data-id="element-94">
                <h2 className="text-4xl font-bold mb-8" data-id="element-95">SYSTEM ARCHITECTURE</h2>
                <div className="space-y-8" data-id="element-96">
                  {[{
                  title: 'Global Network',
                  desc: 'Distributed servers across 42 regions for zero-latency gaming.',
                  icon: Globe
                }, {
                  title: 'Quantum Security',
                  desc: 'Military-grade encryption protecting your digital assets.',
                  icon: Shield
                }, {
                  title: 'Neural Sync',
                  desc: 'Direct brain-computer interface compatibility.',
                  icon: Gamepad2
                }].map((item, i) => <motion.div key={i} initial={{
                  opacity: 0,
                  y: 20
                }} whileInView={{
                  opacity: 1,
                  y: 0
                }} viewport={{
                  once: true
                }} transition={{
                  delay: i * 0.2
                }} className="flex gap-4" data-id="element-97">
                      <div className="w-12 h-12 bg-[#00f0ff]/10 border border-[#00f0ff] flex items-center justify-center flex-shrink-0" data-id="element-98">
                        <item.icon className="w-6 h-6 text-[#00f0ff]" data-id="element-99" />
                      </div>
                      <div data-id="element-100">
                        <h3 className="text-xl font-bold mb-2 font-['Orbitron']" data-id="element-101">
                          {item.title}
                        </h3>
                        <p className="text-gray-400 font-mono text-sm leading-relaxed" data-id="element-102">
                          {item.desc}
                        </p>
                      </div>
                    </motion.div>)}
                </div>
              </div>

              <div className="relative h-[400px] border border-[#ff006e]/30 bg-[#000]/50 p-4" data-id="element-103">
                <div className="absolute inset-0 bg-gradient-to-tr from-[#ff006e]/20 to-transparent pointer-events-none" data-id="element-104" />
                <div className="h-full w-full border border-dashed border-[#ffffff20] flex items-center justify-center" data-id="element-105">
                  <div className="text-center" data-id="element-106">
                    <div className="text-6xl font-black text-[#ffffff10] mb-4" data-id="element-107">
                      404
                    </div>
                    <div className="font-mono text-[#ff006e] animate-pulse" data-id="element-108">
                      SYSTEM DIAGNOSTICS RUNNING...
                    </div>
                  </div>
                </div>

                {/* Decorative lines */}
                <div className="absolute top-0 left-1/4 w-px h-full bg-gradient-to-b from-transparent via-[#00f0ff]/50 to-transparent" data-id="element-109" />
                <div className="absolute top-1/2 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#ff006e]/50 to-transparent" data-id="element-110" />
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-111" />
    </div>;
}